module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/1-aabcdae6f8910972c51c870396aa1201.jpg";